// ==============================================
// ==================Import======================
// ==============================================

// ===================Dependancies================
import PropTypes from 'prop-types';

// ==================Style&IMG===================
import './style.scss';

function Heading({ value }) {
  return (
    <h3 className="headingValue">{value}</h3>
  );
}

Heading.propTypes = {
  value: PropTypes.string.isRequired,
};

export default Heading;
